<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-30 22:42:01
 * @LastEditTime: 2023-08-03 17:22:23
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <div class="product-tab">
        <div class="tab-nav">
            <div class="tab-item" @click="changeTab(index)" :class="{ 'active': active === index }" v-for="(item,index) in tabList" :key="index">
                <div>{{item.title}} </div>
                <div v-show="active === index" class="triangle"></div>
            </div>
        </div>
        <div class="tab-content mt--30" >
            <div class="row">
                <div class="col-12 col-lg-7 col-md-7">
                    <div class="list-wrap">
                        <vyung-scroll ref="scroll" vertical @callbacks="callbacks">
                            <div class="list" :class="{'list-single':!item.description}" v-for="(item,index) in tabList[active].content" :key="index">
                                <div class="icon">
                                    <img :src="item.icon" alt="">
                                </div>
                                <div class="text ml--20" >
                                    <h5 >{{item.title}}</h5> 
                                    <p v-if="item.description">{{item.description}}</p>
                                </div>
                            </div>
                        </vyung-scroll>
                    </div>
                    
                    <router-link :to="{name:tabList[active].name,params:{lang:$i18n.locale}}" class="vyung-button" >{{$t('home.more')}}</router-link> 
                </div>
                <div class="col-12 col-lg-5 col-md-5">
                    <div v-if="active === 3" class="right service_text"  :style="{'background-image': `url(${require(`@/assets/images/${tabList[active].rightImg}`)})`}">
                        <div class="title_first">
                             {{ this.$t('product.VyungService.head.text01') }}
                        <span class="highlight">{{ this.$t('product.VyungService.head.text02') }}</span>
                        {{ this.$t('product.VyungService.head.text03') }}
                        </div>
                        <div class="title_second">
                        <span class="highlight">{{ this.$t('product.VyungService.head.text04') }}</span>
                        {{ this.$t('product.VyungService.head.text05') }}
                        </div>
                        <div class="text_content">
                        <div class="text">
                            <div>{{ this.$t('product.VyungService.head.subtitle01') }}</div>
                            {{ this.$t('product.VyungService.head.subtext01') }}
                        </div>
                        <div class="text">
                            <div>{{ this.$t('product.VyungService.head.subtitle02') }}</div>
                            {{ this.$t('product.VyungService.head.subtext02') }}
                        </div>
                        <div class="text">
                            <div>{{ this.$t('product.VyungService.head.subtitle03') }}</div>
                            {{ this.$t('product.VyungService.head.subtext03') }}
                        </div>
                        </div>                                          
                    </div>
                    <div v-else class="right" :class="[{'workflow':active===4},{'dark':active===2}]" :style="{'background-image': `url(${require(`@/assets/images/${tabList[active].rightImg}`)})`}">
                        <div v-if="tabList[active].rightContent.title" class="title">{{tabList[active]?.rightContent.title}}</div>
                        <span class="line"></span>
                        <div v-if="tabList[active].rightContent.description" class="description">{{active==2?'--':''}} {{tabList[active].rightContent.description}}{{active==2?'--':''}}</div>
                        <div v-if="tabList[active].rightContent.description1" class="description">{{tabList[active].rightContent.description1}}</div>
                        <div v-if="tabList[active].rightContent.description2" class="description">{{tabList[active].rightContent.description2}}</div>
                        <div :class="{'dark':active===2}" v-if="tabList[active].rightContent.subTitle" class="subTitle">{{tabList[active].rightContent.subTitle}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { 
    CPQUniversalModel,
    CPQFlexibleDeployment,
    CPQPerformanceImage,
    CPQSystemIntegrating,
    FCST_icon01,
    FCST_icon02,
    Loyalty_icon01,
    Loyalty_icon02,
    Loyalty_icon03,
    Loyalty_icon04,
    LTC_icon01,
    LTC_icon02,
    LTC_icon03,
    LTC_icon04,
    Service_icon01,
    Service_icon02,
    Service_icon03,
    Service_icon04,
    Workflow_icon01,
    Workflow_icon02,
    Workflow_icon03,
    Workflow_icon04,
    Workflow_icon05,
    Workflow_icon06,
 } from '../ProductService/Image';
import VyungScroll from '@/components/elements/scroll/scroll'
export default {
    name:'HomeProductTab',
    components:{
        VyungScroll
    },
    computed:{
        tabList(){
            return [
                {
                    title:'CPQ',
                    name:"VyungCPQ",
                    rightImg:'home/home_cpq.png',
                    rightContent:{
                        title:'Configure Price Quote',
                        subTitle:this.$t('product.VyungCPQ.head.subtitle'),
                        description: this.$t('product.VyungCPQ.head.text')
                    },
                    content:[{
                        title: this.$t('product.VyungCPQ.product_advangtages.card01.title'),
                        description: this.$t('product.VyungCPQ.product_advangtages.card01.text'),
                        icon:CPQUniversalModel,
                    },
                    {
                        title: this.$t('product.VyungCPQ.product_advangtages.card02.title'),
                        description: this.$t('product.VyungCPQ.product_advangtages.card02.text'),
                        icon:CPQFlexibleDeployment,
                    },
                    {
                        title: this.$t('product.VyungCPQ.product_advangtages.card03.title'),
                        description: this.$t('product.VyungCPQ.product_advangtages.card03.text'),
                        icon:CPQPerformanceImage,
                    },             
                    {
                        title: this.$t('product.VyungCPQ.product_advangtages.card04.title'),
                        description: this.$t('product.VyungCPQ.product_advangtages.card04.text'),
                        icon:CPQSystemIntegrating,
                    }]
                },
                {
                    title:'FCST',
                    name:"VyungFCST",
                    rightImg:'home/home_fcst.png',
                    rightContent:{
                        title:'Forecast',
                        subTitle:this.$t('product.VyungFCST.head.subtitle'),
                        description1: this.$t('product.VyungFCST.head.text01'),
                        description2: this.$t('product.VyungFCST.head.text02')
                    },
                   
                    content:[
                    {
                        title: this.$t('product.VyungFCST.product_advangtages.card01.title'),
                        icon:FCST_icon01,
                    },
                    {
                        title: this.$t('product.VyungFCST.product_advangtages.card02.title'),
                        icon:FCST_icon02,
                    },
                    ]
                },
                {
                    title:'LTC',
                    name:"VyungLTC",
                    rightImg:'home/home_ltc.png',
                    rightContent:{
                        title:'Lead To Cash',
                        subTitle:this.$t('product.VyungLTC.head.subtitle'),
                        description: this.$t('product.VyungLTC.head.text')
                    },
                    content:[
                       
                        {
                            title: this.$t('product.VyungLTC.product_advangtages.card01.title'),
                            description: this.$t('product.VyungLTC.product_advangtages.card01.text'),
                            icon:LTC_icon01,
                        },
                        {
                            title: this.$t('product.VyungLTC.product_advangtages.card02.title'),
                            description: this.$t('product.VyungLTC.product_advangtages.card02.text'),
                            icon:LTC_icon02,
                        },
                        {
                            title: this.$t('product.VyungLTC.product_advangtages.card03.title'),
                            description: this.$t('product.VyungLTC.product_advangtages.card03.text'),
                            icon:LTC_icon03,
                        },             
                        {
                            title: this.$t('product.VyungLTC.product_advangtages.card04.title'),
                            description: this.$t('product.VyungLTC.product_advangtages.card04.text'),
                            icon:LTC_icon04,
                        }
                   ]
                },
                {
                    title:'Service',
                    name:"VyungService",
                    rightImg:'home/home_service.png',
                    content:[
                        
                        {
                            title: this.$t('product.VyungService.product_advangtages.card01.title'),
                            description: this.$t('product.VyungService.product_advangtages.card01.text'),
                            icon:Service_icon01,
                        },
                        {
                            title: this.$t('product.VyungService.product_advangtages.card02.title'),
                            description: this.$t('product.VyungService.product_advangtages.card02.text'),
                            icon:Service_icon02,
                        },
                        {
                            title: this.$t('product.VyungService.product_advangtages.card03.title'),
                            description: this.$t('product.VyungService.product_advangtages.card03.text'),
                            icon:Service_icon03,
                        },             
                        {
                            title: this.$t('product.VyungService.product_advangtages.card04.title'),
                            description: this.$t('product.VyungService.product_advangtages.card04.text'),
                            icon:Service_icon04,
                        }
                   ]
                },
                {
                    title:'Workflow',
                    name:"VyungWorkflow",
                    rightImg:'home/home_workflow.png',
                    rightContent:{
                        title:'Workflow',
                        subTitle:this.$t('product.VyungWorkflow.head.subtitle'),
                        description1: this.$t('product.VyungWorkflow.head.text01'),
                        description2: this.$t('product.VyungWorkflow.head.text02')
                    },
                    content:[
                    {
                        title: this.$t('product.VyungWorkflow.product_advangtages.card01.title'),
                        description: this.$t('product.VyungWorkflow.product_advangtages.card01.text'),
                        icon:Workflow_icon01,
                    },
                    {
                        title: this.$t('product.VyungWorkflow.product_advangtages.card02.title'),
                        description: this.$t('product.VyungWorkflow.product_advangtages.card02.text'),
                        icon:Workflow_icon02,
                    },
                    {
                        title: this.$t('product.VyungWorkflow.product_advangtages.card03.title'),
                        description: this.$t('product.VyungWorkflow.product_advangtages.card03.text'),
                        icon:Workflow_icon03,
                    },             
                    {
                        title: this.$t('product.VyungWorkflow.product_advangtages.card04.title'),
                        description: this.$t('product.VyungWorkflow.product_advangtages.card04.text'),
                        icon:Workflow_icon04,
                    },             
                    {
                        title: this.$t('product.VyungWorkflow.product_advangtages.card05.title'),
                        description: this.$t('product.VyungWorkflow.product_advangtages.card05.text'),
                        icon:Workflow_icon05,
                    },             
                    {
                        title: this.$t('product.VyungWorkflow.product_advangtages.card06.title'),
                        description: this.$t('product.VyungWorkflow.product_advangtages.card06.text'),
                        icon:Workflow_icon06,
                    }
                   ]
                },
                {
                    title:'Loyalty',
                    name:'VyungLoyalty',
                    rightImg:'home/home_loyalty.png',
                    rightContent:{
                        title:'Loyalty',
                        subTitle:this.$t('product.VyungLoyalty.head.subtitle'),
                        description: this.$t('product.VyungLoyalty.head.text')
                    },
                    content:[
                        {
                            title: this.$t('product.VyungLoyalty.product_advantages.card01.title'),
                            description: this.$t('product.VyungLoyalty.product_advantages.card01.text'),
                            icon:Loyalty_icon01,
                        },
                        {
                            title:this.$t('product.VyungLoyalty.product_advantages.card02.title'),
                            description: this.$t('product.VyungLoyalty.product_advantages.card02.text'),
                            icon:Loyalty_icon02,
                        },
                        {
                            title: this.$t('product.VyungLoyalty.product_advantages.card03.title'),
                            description: this.$t('product.VyungLoyalty.product_advantages.card03.text'),
                            icon:Loyalty_icon03,
                        },
                        {
                            title: this.$t('product.VyungLoyalty.product_advantages.card04.title'),
                            description: this.$t('product.VyungLoyalty.product_advantages.card04.text'),
                            icon:Loyalty_icon04,
                        },
                   ]
                }
            ]
        }
    },
    data(){
        return{
            active:0,
            obj: null
        }
    },
    methods: {
      callbacks(obj) {
        this.obj = obj
      },
      changeTab(index){
       const el = this.$el.querySelector('#listwrap')
        // const el = document.getElementById('listwrap')
        this.active = index
        this.$nextTick(()=>{
            this.$refs.scroll._initScroll()
            // console.log(el)
            // this.$refs.scroll.style.top = 0
            // this.$refs.scroll._animated(el, 'top')
            // this.$refs.scroll._scrollY_To(0)
            // el.scrollTo(0,0);
        })
      }
    }
}
</script>